module.exports = __webpack_public_path__ + "img/TabbottLogo.25eacf84.svg";